import React from 'react';
import BaseQuestionnaire from './BaseQuestionnaire';
import RadioGroup from '../RadioGroup';

const OrientationConscienceQuestionnaire = () => {
  return (
    <BaseQuestionnaire>
      {({
        questionnaireConfig,
        currentQuestions,
        currentPage,
        answers,
        handleAnswerChange,
        QUESTIONS_PER_PAGE,
      }) => (
        <>
          {/* Questions Container */}
          <div className="questions-container">
            {currentQuestions.map((question, index) => {
              const globalIndex = currentPage * QUESTIONS_PER_PAGE + index;
              return (
                <div key={globalIndex} id={`question-${globalIndex}`} className="question-card">
                  <div className="question-text">
                    <strong>Question {globalIndex + 1}:</strong> {question.text}
                  </div>
                  
                  {/* 7-point scale with square buttons */}
                  <div>
                    <div className="scale-labels" style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      marginBottom: '1rem',
                      fontSize: '0.9rem',
                      color: '#7f8c8d'
                    }}>
                      <span>{questionnaireConfig.scaleLabels[0]}</span>
                      <span>{questionnaireConfig.scaleLabels[6]}</span>
                    </div>
                    
                    <RadioGroup
                      name={`question_${globalIndex}`}
                      value={answers[globalIndex]}
                      onChange={(value) => handleAnswerChange(index, value)}
                      options={questionnaireConfig.scaleLabels.map((label, scaleIndex) => ({
                        value: scaleIndex + 1,
                        label: label
                      }))}
                      renderLabel={(option, scaleIndex) => 
                        scaleIndex === 0 ? `${option.label} (${option.value})` : 
                        scaleIndex === 6 ? `${option.label} (${option.value})` : 
                        `(${option.value})`
                      }
                    />
                  </div>
                </div>
              );
            })}
          </div>

          {/* Guide Section */}
          <div className="card" style={{ marginTop: '2rem' }}>
            <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>
              Guide de réponse
            </h3>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              padding: '1rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>1</div>
                <div style={{ fontSize: '0.9rem', color: '#7f8c8d' }}>Ne me décrit pas du tout/jamais</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>2-3</div>
                <div style={{ fontSize: '0.9rem', color: '#7f8c8d' }}>Me décrit peu/rarement</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>4</div>
                <div style={{ fontSize: '0.9rem', color: '#7f8c8d' }}>Neutre</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>5-6</div>
                <div style={{ fontSize: '0.9rem', color: '#7f8c8d' }}>Me décrit bien/souvent</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>7</div>
                <div style={{ fontSize: '0.9rem', color: '#7f8c8d' }}>Me décrit parfaitement/toujours</div>
              </div>
            </div>
            <div style={{ 
              marginTop: '1rem', 
              padding: '1rem',
              backgroundColor: '#e8f5e8',
              borderRadius: '8px',
              fontSize: '0.9rem'
            }}>
              <strong>💡 Conseil :</strong> Répondez instinctivement à chaque affirmation. 
              Il n'y a pas de bonnes ou mauvaises réponses, seulement votre perception personnelle.
            </div>
          </div>
        </>
      )}
    </BaseQuestionnaire>
  );
};

export default OrientationConscienceQuestionnaire;
